
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(160|794|971)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
